import { useQuery } from '@tanstack/vue-query'
import { getRentReceiptCounts } from '../rentReceiptsEndpoints'
import { rentReceiptKeys } from '../rentReceiptsQueryKeys'

/** Backs the queue tabs and the sidebar "needs attention" badge. */
export function useRentReceiptCountsQuery() {
  return useQuery({
    queryKey: rentReceiptKeys.counts(),
    queryFn: getRentReceiptCounts,
  })
}
